import { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

// Mapeamento de atalhos de teclado
const SHORTCUTS = {
  // Navegação principal (Alt + letra)
  'alt+d': { path: '/dashboard', label: 'Dashboard' },
  'alt+r': { path: '/recepcao', label: 'Recepção' },
  'alt+m': { path: '/montagem', label: 'Montagem' },
  'alt+c': { path: '/ciclos', label: 'Ciclos' },
  'alt+a': { path: '/arsenal', label: 'Arsenal' },
  'alt+g': { path: '/agendamentos', label: 'Agendamentos' },
  'alt+f': { path: '/financeiro', label: 'Financeiro' },
  'alt+e': { path: '/estoque', label: 'Estoque' },
  'alt+l': { path: '/clientes', label: 'Clientes' },
  'alt+t': { path: '/materiais', label: 'Materiais' },
  'alt+u': { path: '/autoclaves', label: 'Autoclaves' },
  'alt+p': { path: '/pops', label: 'POPs' },
  'alt+o': { path: '/relatorios', label: 'Relatórios' },
  
  // Ações rápidas (Ctrl + letra)
  'ctrl+k': { action: 'search', label: 'Busca Rápida' },
  'ctrl+n': { action: 'new', label: 'Novo Item' },
  'ctrl+h': { action: 'help', label: 'Ajuda/Atalhos' },
  
  // Escape
  'escape': { action: 'close', label: 'Fechar Modal' },
};

export function useKeyboardShortcuts(options = {}) {
  const navigate = useNavigate();
  const { 
    onSearch, 
    onNew, 
    onHelp, 
    onClose,
    enabled = true 
  } = options;

  const handleKeyDown = useCallback((event) => {
    if (!enabled) return;
    
    // Ignorar se estiver digitando em um input/textarea
    const tagName = event.target.tagName.toLowerCase();
    if (['input', 'textarea', 'select'].includes(tagName) && event.key !== 'Escape') {
      return;
    }

    // Construir a combinação de teclas
    const keys = [];
    if (event.ctrlKey) keys.push('ctrl');
    if (event.altKey) keys.push('alt');
    if (event.shiftKey) keys.push('shift');
    keys.push(event.key.toLowerCase());
    
    const combo = keys.join('+');
    const shortcut = SHORTCUTS[combo];
    
    if (!shortcut) return;
    
    event.preventDefault();
    
    // Navegação
    if (shortcut.path) {
      navigate(shortcut.path);
      return;
    }
    
    // Ações
    switch (shortcut.action) {
      case 'search':
        onSearch?.();
        break;
      case 'new':
        onNew?.();
        break;
      case 'help':
        onHelp?.();
        break;
      case 'close':
        onClose?.();
        break;
      default:
        break;
    }
  }, [navigate, onSearch, onNew, onHelp, onClose, enabled]);

  useEffect(() => {
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [handleKeyDown]);

  return { shortcuts: SHORTCUTS };
}

// Lista de atalhos para exibição na UI
export const SHORTCUT_LIST = [
  { category: 'Navegação', shortcuts: [
    { keys: 'Alt + D', action: 'Dashboard' },
    { keys: 'Alt + R', action: 'Recepção' },
    { keys: 'Alt + M', action: 'Montagem' },
    { keys: 'Alt + C', action: 'Ciclos' },
    { keys: 'Alt + A', action: 'Arsenal' },
    { keys: 'Alt + G', action: 'Agendamentos' },
    { keys: 'Alt + F', action: 'Financeiro' },
    { keys: 'Alt + E', action: 'Estoque' },
    { keys: 'Alt + L', action: 'Clientes' },
    { keys: 'Alt + T', action: 'Materiais' },
    { keys: 'Alt + U', action: 'Autoclaves' },
    { keys: 'Alt + P', action: 'POPs' },
    { keys: 'Alt + O', action: 'Relatórios' },
  ]},
  { category: 'Ações', shortcuts: [
    { keys: 'Ctrl + K', action: 'Busca Rápida' },
    { keys: 'Ctrl + N', action: 'Novo Item' },
    { keys: 'Ctrl + H', action: 'Ajuda/Atalhos' },
    { keys: 'Esc', action: 'Fechar Modal' },
  ]},
];
